import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/index/banner.jpg';
import _imports_1 from '@/assets/images/index/zs.png';
import _imports_2 from '@/assets/images/index/jt.png';
const _withScopeId = n => (_pushScopeId("data-v-20bb7e9d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "banner-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  src: "https://cdn-ticprint-cos.ticprint.com/ticprintwebsit/2025-03/mp4/43f4c183f6dda369b114c06da7f070f8.mp4",
  poster: _imports_0,
  muted: "",
  loop: "",
  autoplay: ""
}, null, -1));
const _hoisted_3 = {
  class: "banner-main"
};
const _hoisted_4 = {
  class: "banner-box"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner-title"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "97"
}), /*#__PURE__*/_createTextVNode(" From Creativity to Reality: "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" Your One-Stop 3D Printing Solution. "), /*#__PURE__*/_createElementVNode("img", {
  class: "sec",
  src: _imports_2,
  alt: "",
  width: "114"
})], -1));
const _hoisted_6 = {
  class: "banner-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: "banner-btn-main",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('goPage'))
  }, " Start for free ")])])])]);
}